import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import MapWaterLevelComponent from "../waterLevel/WaterLevel";

const WaterLevelPage = () => {
  return (
    <Box h="100dvh" display="flex" flexDirection="column">
      <Navbar />
      <Box flex="1" zIndex={1}>
        <MapWaterLevelComponent />
      </Box>
    </Box>
  );
};

export default WaterLevelPage;
